import { axios } from '@/utils/request'

// 售后反馈 - 售后反馈列表
export function getFeedbackList(parameter) {
  return axios({
    url: '/merchant.php/sale_feedback/getList',
    method: 'get',
    params: parameter
  })
}

// 售后反馈 - 修改备注
export function postEditFeedbackRemark(data) {
  return axios({
    url: '/merchant.php/sale_feedback/remark',
    method: 'post',
    data: data
  })
}

// 会员登记 - 会员登记列表
export function getRecordList(parameter) {
  return axios({
    url: '/merchant.php/sale_record/getList',
    method: 'get',
    params: parameter
  })
}
